(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (function () {
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let observer = null;
    let failSafeTimer = null;

    function reveal(el) {
      el.classList.add('ak-reveal--visible');
    }

    function getObserver() {
      if (observer) return observer;

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
      );

      return observer;
    }

    /* Safety net: if a card is still hidden but sitting on screen shortly
       after a re-render, just show it. A visible product beats an animation. */
    function scheduleFailSafe() {
      clearTimeout(failSafeTimer);
      failSafeTimer = setTimeout(() => {
        document.querySelectorAll('.ak-reveal:not(.ak-reveal--visible)').forEach((el) => {
          const rect = el.getBoundingClientRect();
          const onScreen = rect.top < window.innerHeight && rect.bottom > 0;
          if (onScreen) reveal(el);
        });
      }, 1200);
    }

    function init() {
      const items = document.querySelectorAll('.ak-reveal:not(.ak-reveal--visible)');
      if (!items.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach(reveal);
        return;
      }

      const obs = getObserver();
      items.forEach((item) => obs.observe(item));
      scheduleFailSafe();
    }

    /* Re-run whenever the grid is re-rendered: sort, filter, infinite scroll,
       pagination, or a theme-editor update. */
    function watchForRerenders() {
      const target = document.querySelector('results-list') || document.body;
      if (!target || target.dataset.akRevealWatched) return;
      target.dataset.akRevealWatched = '1';

      let queued = false;
      const mo = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          init();
        });
      });

      mo.observe(target, { childList: true, subtree: true });
    }

    function boot() {
      init();
      watchForRerenders();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('page:loaded', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal(el) {
      el.classList.add('ak-plist-reveal--visible');
    }

    function init() {
      const items = document.querySelectorAll('.ak-plist-reveal:not(.ak-plist-reveal--visible)');
      if (!items.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach(reveal);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
      );

      items.forEach((item) => observer.observe(item));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('page:loaded', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
